import { CustomerButtonProps } from "./types"
import React from "react"
import { StyleSheet, Image } from "~/ui/primitives"
import styled from '~/ui/styled'

import Icon from "~widgets/icon"

const customerImg = require("../../assets/images/wallet/customer.png")

const Wrap = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border-width: ${StyleSheet.hairlineWidth}px;
  border-color: #ccc;
`
const Content = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
const Row = styled.TouchableOpacity`
  padding: 4px 8px;
`
const Line = styled.TouchableOpacity`
  width: ${StyleSheet.hairlineWidth}px;
  height: 14px;
  background-color: #ccc;
`

const CustomerButton: React.FC<CustomerButtonProps> = ({
  insideVisible = true,
  onClick,
  onPressOutside,
}) => {
  if (insideVisible) {
    return (
      <Wrap>
        <Row onClick={onClick}>
          <Image src={customerImg} style={{ width: 16, height: 16 }} />
        </Row>
        <Line />
        <Row onClick={onPressOutside}>
          <Icon name={"record"} color={"#000"} size={16} />
        </Row>
      </Wrap>
    )
  } else {
    return (
      <Content onClick={onClick}>
        <Image src={customerImg} style={{ width: 20, height: 20 }} />
      </Content>
    )
  }
}

export default CustomerButton
